import moment, { Moment } from 'moment';
import React from 'react'
import { useDispatch } from 'react-redux';
import { setOrderForTile, setShowOrderTrackingDetail } from '../../../actions';
import './VerifiedOrderList.scss';
import { getShippingType, getShippingStatus } from './VerifiedOrderUtils';
import { getDeliveryTime } from '../../util/dateTimeHelper';
import { isDeliveryDateToday } from '../../util/commonUtil';

type VerifiedOrderListProps = {
    orderList: any
}

const VerifiedOrderList = ({orderList}: VerifiedOrderListProps) => {
    const dispatch = useDispatch();

    const changeDetailFlag = (order: any) => {
        if (!order.isSubscription) {
            dispatch(setShowOrderTrackingDetail(true)); 
            dispatch(setOrderForTile(order));
        }
    }
    
    return (
        <div className="verifiedOrder__parent">
            {
              orderList.map((data: any, index: number) => {
                let deliveryDate:Moment;
                let deliveryTypeString;
                let estimatedDeliveryDateText = '';
                let estimatedDeliveryTimeText='';
                let orderDate:Moment;
                let orderId;
                let products;
                let isSubscription = data.isSubscription ?? false;
                let extraDeliveryInfo = '';
                let iconUrl = '';
                let deliveryCount = 0;
                let status;
                
                deliveryCount = data.deliveryCount;
                deliveryTypeString = '';
                orderId = data.orderId;
                status = data.status;
                let deliveryDatesAllConsignments = data.consignmentShippingTypes.map((shippingType:string) => {
                    orderDate = moment(data.orderDate);
                    deliveryDate = moment(data.deliveryDate);

                    let { deliveryType, calculatedDeliveryDate, shippingIconUrl } = getShippingType(shippingType, orderDate, deliveryDate);

                    // if the delivery type is Supplier, show a standard delivery
                    deliveryTypeString = (deliveryType === 'Supplier')? 'Standard' : deliveryType;

                    iconUrl = shippingIconUrl;

                    return calculatedDeliveryDate;
                });

                let { deliveryStatus, shippingIconUrl } = getShippingStatus(data.status);

                let sortedDates = deliveryDatesAllConsignments.sort(
                    (a:Date, b:Date) => new Date(b).getTime() - new Date(a).getTime()
                );
                
                // get the latest date
                estimatedDeliveryDateText= moment(sortedDates[0]).format('DD MMM');
                estimatedDeliveryTimeText= moment(sortedDates[0], "HH:mm:ss").format("LT");
                const deliveryTime = getDeliveryTime(moment(data?.deliveryDate)?.format("HH:mm:ss").toString());
                const deliveryStartTime = deliveryTime[0];
                const deliveryEndTime = deliveryTime[1];

                const isDeliveryToday = isDeliveryDateToday(data?.deliveryDate);

                products = data.productImages;

                return (
                <div className="verifiedOrder__container"  key={ "order" + index } onClick={ () => changeDetailFlag(data) } >
                    <div className='verifiedOrder__container-orderinfo'>
                        <div className='verifiedOrder__container-orderinfo--orderlabel'>
                            <img src={ shippingIconUrl } width="20px" height="20px" alt="icon" />
                            <span className='verifiedOrder__container-orderinfo--ordertype'>{ deliveryStatus }</span>
                        </div>
                        <div className='verifiedOrder__container-ordernumber'>
                           Order # { orderId } 
                        </div>
                    </div>
                    
                    { isDeliveryToday ?
                        <span className='verifiedOrder__container-deliveryBy'>
                            <span className="verifiedOrder__container-deliveryBy-text">Expected delivery: </span><strong className='verifiedOrder__container-deliveryBy-date'>{moment(deliveryStartTime, "HH:mm:ss").format("LT")} - {moment(deliveryEndTime, "HH:mm:ss").format("LT")}, today</strong>
                        </span>:

                        <span className='verifiedOrder__container-deliveryBy'>
                            <span className="verifiedOrder__container-deliveryBy-text">Expected delivery on: </span><strong className='verifiedOrder__container-deliveryBy-date'>{  moment(data.deliveryDate).format('DD MMM') }, {moment(deliveryStartTime, "HH:mm:ss").format("LT")} - {moment(deliveryEndTime, "HH:mm:ss").format("LT")}</strong>
                        </span>

                    }
                   
                    <div className='verifiedOrder__container-products'>
                    {
                        products.map(( productImage: any, indexinner: number) => {
                            return (
                            indexinner < 4 &&
                            <div className="verifiedOrder__container-products--icon" key={ "icon" + indexinner }>
                                {
                                    indexinner === 3 && <span>+{ products.length - 3 } </span>
                                }

                                {   indexinner === 3 &&
                                    <div className="verifiedOrder__container-products--icon---cover"></div>
                                }

                                {
                                    <div className="verifiedOrder__container-products--icon---image" style={{
                                        backgroundImage: "url(" + productImage + ")",
                                        backgroundColor: (indexinner === 3) ? '#474947' : 'transparent'
                                    }}>

                                    </div>
                                }
                            </div>)
                            
                            })
                    }
                    </div>
                </div>)
            })
            
            }
        </div>
    )
}

export default VerifiedOrderList
